import React from 'react';
import classes from './Card.module.css';

const Card=(props)=>{

    return(
    <div className={classes.card}>
    <div className={classes.heading}>{props.children}</div>
    <h1  className={classes.data}>{props.data}</h1>
    </div>)


}


export default Card;